import axios from 'axios';

import { HttpRoutes } from 'utils/constant';


export const reviewResponse = async (payload) => {
  return await axios
    .post(HttpRoutes.reviewResponse, payload)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error?.response || error;
    });
};
